module.exports = __webpack_public_path__ + "img/kosovo.e2ef72ae.svg";